var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdDigital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 6,
    fill: "url(#paint0_linear_1901_2616)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.245 13.639 L 3.424 13.639 L 3.424 5.384 L 8.187 5.384 L 8.187 6.339 L 4.702 6.339 L 4.702 8.865 L 8.013 8.865 L 8.013 9.82 L 4.702 9.82 L 4.702 12.684 L 8.245 12.684 L 8.245 13.639 Z",
    fill: "white",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.407 15.59 L 15.875 15.59 L 15.875 14.639 L 9.407 14.639 L 9.407 15.59 Z",
    fill: "white",
    style: {}
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1901_2616",
    x1: 0.747991,
    y1: 0.582667,
    x2: 17.6217,
    y2: 18.4173,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.055556, 0, 0, 1.02156, -0.527778, -0.204312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4100"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdDigital);
export default __webpack_public_path__ + "static/media/ed-digital.91ad1c5d6b5673a1f855bda9b0bd60d5.svg";
export { ForwardRef as ReactComponent };